/* globals Blob */
import { OUTBOUND_SHIPMENT_TEMPLATE_HEADERS, OUTBOUND_TEMPLATE_COLUMNS } from '@fielded/fs-api/lib/shipment/constants'

export const COLUMNS = [
  {
    key: 'destinationWarehouseCode',
    header: 'Destination Warehouse Code',
    dataKey: 'destinationWarehouseCode',
    disableSort: true
  },
  {
    key: 'product',
    header: 'Product',
    dataKey: 'product',
    disableSort: true,
    headerClassName: 'shipment-upload-table-header__width'
  },
  {
    key: 'quantity',
    header: 'Quantity',
    dataKey: 'quantity',
    disableSort: true
  },
  {
    key: 'originWarehouseCode',
    header: 'Origin Warehouse Code',
    dataKey: 'originWarehouseCode',
    disableSort: true
  },
  {
    key: 'externalId',
    header: 'External ID',
    dataKey: 'externalId',
    disableSort: true
  },
  {
    key: 'date',
    header: 'Date',
    dataKey: 'date',
    disableSort: true,
    headerClassName: 'shipment-upload-table-header__width'
  },
  {
    key: 'lotNo',
    header: 'Batch No',
    dataKey: 'lotNo',
    disableSort: true
  },
  {
    key: 'manufacturer',
    header: 'Manufacturer',
    dataKey: 'manufacturer',
    disableSort: true
  },
  {
    key: 'expiry',
    header: 'Expiry',
    dataKey: 'expiry',
    disableSort: true,
    headerClassName: 'shipment-upload-table-header__width'
  }
]

export const ROWS = {
  default: [
    {
      destinationWarehouseCode: '16020',
      product: 'epn-amo002',
      quantity: '300',
      originWarehouseCode: 'KE-EPN-CHAK',
      externalId: '001',
      date: '2024-01-01',
      lotNo: '324',
      manufacturer: 'axmed',
      expiry: '2040-01-01'
    },
    {
      destinationWarehouseCode: '15864',
      product: 'epn-amo002',
      quantity: '100',
      originWarehouseCode: 'KE-EPN-CHAK',
      externalId: '001',
      date: '2024-01-01',
      lotNo: '325',
      manufacturer: 'axmed',
      expiry: '2040-01-01'
    }
  ],
  epn: {
    ng: [
      {
        destinationWarehouseCode: 'PSM/NONSTATE/00/049',
        product: 'epn-amd-250-cmp001',
        quantity: '300',
        originWarehouseCode: 'NG-EPN-JOS',
        externalId: '001',
        date: '01-01-2024',
        lotNo: '326',
        manufacturer: 'axmed',
        expiry: '01-01-2040'
      },
      {
        destinationWarehouseCode: 'PSM/NONSTATE/00/049',
        product: 'epn-azt500-cmp002',
        quantity: '100',
        originWarehouseCode: 'NG-EPN-JOS',
        externalId: '001',
        date: '01-01-2024',
        lotNo: '327',
        manufacturer: 'axmed',
        expiry: '01-01-2040'
      }
    ],
    ke: [
      {
        destinationWarehouseCode: '16020',
        product: 'epn-amo001',
        quantity: '300',
        originWarehouseCode: 'KE-EPN-CHAK',
        externalId: '001',
        date: '01-01-2024',
        lotNo: '326',
        manufacturer: 'axmed',
        expiry: '01-01-2040'
      },
      {
        destinationWarehouseCode: '15864',
        product: 'epn-amo002',
        quantity: '100',
        originWarehouseCode: 'KE-EPN-CHAK',
        externalId: '001',
        date: '01-01-2024',
        lotNo: '327',
        manufacturer: 'axmed',
        expiry: '01-01-2040'
      }
    ]
  },
  rms: {
    rw: [
      {
        destinationWarehouseCode: '5002',
        product: '100ARCH055',
        quantity: '300',
        originWarehouseCode: '5001',
        externalId: '001',
        date: '01-01-2024',
        lotNo: '05315UN24',
        manufacturer: 'RMS',
        expiry: '24-09-2025'
      },
      {
        destinationWarehouseCode: '5002',
        product: '100ARCH011',
        quantity: '100',
        originWarehouseCode: '5001',
        externalId: '001',
        date: '01-01-2024',
        lotNo: '69122FZ00',
        manufacturer: 'RMS',
        expiry: '31-03-2025'
      }
    ]
  }
}

export const getFormattedValue = (value) => new Intl.NumberFormat().format(value)

export const getErrorListItems = (errorList, numItems = 1) => {
  return errorList.slice(0, numItems)
}

export const transformErrorMessage = (message, reasons) => {
  if (reasons.length === 1) {
    return message
  }
  return `${message}. We have ${reasons.length} affected, only displaying 1 item.`
}

/**
 * Check if a file is an Excel file
 * @param {File} file - The file to check
 * @returns {boolean}
 */
export const isExcelFile = (file) => {
  const excelMimeTypes = [
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/wps-office.xlsx'
  ]

  const excelExtensions = ['.xlsx', '.xls']

  return excelMimeTypes.includes(file.type) || excelExtensions.some(ext => file.name.toLowerCase().endsWith(ext))
}

/**
 * Generate and download Excel template for outbound shipments
 */
export const generateOutBoundExcelTemplate = async ({
  toast,
  api,
  warehouseCode,
  facilitiesExamples,
  productExamples,
  country,
  setIsExcelTemplateDownloading
}) => {
  setIsExcelTemplateDownloading(true)
  try {
    const file = await api.shipment.getOutboundExcelTemplate({
      warehouseCode,
      facilities: facilitiesExamples,
      products: productExamples
    })
    const url = window.URL.createObjectURL(file)
    const a = document.createElement('a')
    a.href = url
    a.download = `shipment-template-${country}.xlsx`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
  } catch (e) {
    toast({
      title: 'Error downloading template',
      type: 'warning',
      children: e.message || 'Failed to download the Excel template.',
      autoDismiss: false
    })
  } finally {
    setIsExcelTemplateDownloading(false)
  }
}

/**
 * Generate and download CSV template for outbound shipments
 * @param {Object} params - Parameters for CSV generation
 * @param {Function} params.toast - Toast notification function
 * @param {string} params.warehouseCode - Origin warehouse code
 * @param {Array} params.facilitiesExamples - Array of facility objects
 * @param {Array} params.productExamples - Array of product objects
 * @param {string} params.country - Country code for filename
 * @param {Function} params.setIsCSVTemplateDownloading - State setter
 */
export const generateOutBoundCSVTemplate = ({
  toast,
  warehouseCode,
  facilitiesExamples = [],
  productExamples = [],
  country,
  setIsCSVTemplateDownloading
}) => {
  setIsCSVTemplateDownloading(true)

  try {
    const headers = OUTBOUND_SHIPMENT_TEMPLATE_HEADERS.AGAVE_CSV

    const rows = []
    const numSampleRows = 2

    for (let i = 0; i < numSampleRows; i++) {
      const facility = facilitiesExamples[i]
      const product = productExamples[i]

      const rowDataMap = {
        [OUTBOUND_TEMPLATE_COLUMNS.DESTINATION_WAREHOUSE_CODE]: facility.additionalData.warehouseCode || 'PSM/NONSTATE/00/049',
        [OUTBOUND_TEMPLATE_COLUMNS.PRODUCT]: product.code.toLowerCase() || 'epn-amd-250-cmp001',
        [OUTBOUND_TEMPLATE_COLUMNS.QUANTITY]: '',
        [OUTBOUND_TEMPLATE_COLUMNS.ORIGIN_WAREHOUSE_CODE]: warehouseCode || 'NG-EPN-JOS',
        [OUTBOUND_TEMPLATE_COLUMNS.EXTERNAL_ID]: '',
        [OUTBOUND_TEMPLATE_COLUMNS.DATE]: '',
        [OUTBOUND_TEMPLATE_COLUMNS.MANUFACTURER]: '',
        [OUTBOUND_TEMPLATE_COLUMNS.EXPIRY]: '',
        [OUTBOUND_TEMPLATE_COLUMNS.BATCH_NO]: ''
      }

      const row = headers.map(header => rowDataMap[header] || '')
      rows.push(row)
    }

    const csvContent = [
      headers.join(','),
      ...rows.map(row => row.join(','))
    ].join('\n')

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `shipment-template-${country}.csv`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  } catch (error) {
    toast({
      title: 'Error downloading CSV template',
      type: 'warning',
      children: error.message || 'Failed to download the CSV template.',
      autoDismiss: false
    })
  } finally {
    setIsCSVTemplateDownloading(false)
  }
}
